// Cryptographic hash service for SOC-compliant audit trails
export async function generateHash(data: string): Promise<string> {
  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(data);
  const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

export async function verifyHashChain(
  records: Array<{ record_hash: string | null; previous_record_hash: string | null; created_at: string }>
): Promise<{ valid: boolean; brokenAt?: number }> {
  if (records.length === 0) return { valid: true };

  // Sort by created_at ascending
  const sorted = [...records].sort((a, b) => 
    new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );

  for (let i = 1; i < sorted.length; i++) {
    const current = sorted[i];
    const previous = sorted[i - 1];

    // Check if current record's previous_record_hash matches previous record's record_hash
    if (current.previous_record_hash !== previous.record_hash) {
      return { valid: false, brokenAt: i };
    }
  }

  return { valid: true };
}

export function createRecordFingerprint(record: any): string {
  // Create a deterministic string representation for hashing
  const normalized = {
    entity_type: record.entity_type,
    entity_id: record.entity_id,
    action: record.action,
    severity: record.severity,
    user_id: record.user_id,
    details: record.details,
    created_at: record.created_at,
  };
  return JSON.stringify(normalized, Object.keys(normalized).sort());
}
